<template>
  <section>
    <div
      class="p-12 bg-gray-100 border border-gray-300"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
    >
      <input
        :id="`assetsFieldHandle${nameInput}`"
        ref="file"
        type="file"
        :name="`fields[assetsFieldHandle${nameInput}][]`"
        class="w-px h-px opacity-0 overflow-hidden absolute"
        @change="onChange($event)"
      />

      <label
        :for="`assetsFieldHandle${nameInput}`"
        class="block cursor-pointer"
      >
        <div>
          <span class="underline">clique aqui</span> para fazer o upload.
          <br />
          <span class="extension"
            >Atenção: Só é aceito arquivos com extensão
            {{ acceptImg ? ".jpg / .jpeg / .heic" : ".pdf" }}</span
          >
        </div>
      </label>
    </div>

    <v-alert v-if="dialogUpload.invalidFormatFile" type="warning" class="mt-2">
      Arquivo com extensão inválida.
    </v-alert>

    <v-alert v-if="dialogUpload.invalidFilesSize" type="warning" class="mt-2">
      Tamanho do arquivo ultrapassa o limite permitido de 50MB.
    </v-alert>
  </section>
</template>

<script>
export default {
  name: "UploadFile",
  delimiters: ["${", "}"],
  props: {
    nameInput: {
      type: Number,
    },
    value: {
      type: [File, String, Object],
    },
    acceptImg: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialogUpload: {
      open: false,
      form: {
        files: [],
      },
      isLoading: false,
      invalidFilesSize: false,
      invalidFormatFile: false,
    },
    typeImages: ["image/jpeg", "image/jpg", "image/png", "image/heic"],
  }),
  watch: {
    "dialogUpload.form.files": function (newValue, oldValue) {
      this.validateFilesSize(newValue);
      this.validateFormatFile(newValue);
    },
  },
  methods: {
    onChange(event) {
      this.dialogUpload.form.files = [this.$refs.file.files[0]];

      // const reader = new FileReader()
      // reader.addEventListener('load', () =>{
      //   console.log(reader.result)
      //   this.$emit("input", reader.result);
      // })
      // reader.readAsDataURL(this.$refs.file.files[0])

      this.$emit("input", this.$refs.file.files[0]);
      this.$emit("change", event);
    },
    remove(file) {
      this.dialogUpload.form.files = [];
      this.$emit("change", this.dialogUpload.form.files);
      this.$emit("input", null);
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },
    validateFilesSize(file) {
      if (!file.length) return;
      const fileSize = Math.round(file[0].size / 1024); // converte bytes to kbytes
      const limitFilesSize = 50000; // 5MB
      if (fileSize > limitFilesSize) {
        this.dialogUpload.invalidFilesSize = true;
        this.$emit("input", null);
      } else {
        this.dialogUpload.invalidFilesSize = false;
      }
    },
    validateFormatFile(files) {
      if (!files.length) return;

      this.checkIfDocumentAceptedImg(files);
    },
    async checkIfDocumentAceptedImg(files) {
      for (const file of files) {
        let typeDoc = this.acceptImg ? "image/" : "application/pdf";
        let hasFormaInvalid = "";
        if (this.acceptImg) {
          // Só aceita imagem
          hasFormaInvalid = !(await this.isRealIMG(file));
        } else {
          // Só aceita PDF
          hasFormaInvalid = !(await this.isRealPDF(file));
        }
        if (hasFormaInvalid) {
          this.dialogUpload.invalidFormatFile = true;
          this.$emit("input", null);
        } else {
          this.dialogUpload.invalidFilesSize = false;
          this.dialogUpload.invalidFormatFile = false;
        }
      }
    },
    async isRealPDF(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onloadend = function (e) {
          const arr = new Uint8Array(e.target.result);

          // Pega o início do arquivo
          const start = String.fromCharCode(...arr.subarray(0, 5));

          // Pega o final do arquivo (últimos ~20 bytes, suficiente para %%EOF)
          const endBytes = arr.subarray(arr.length - 20);
          const end = new TextDecoder().decode(endBytes);

          const validStart = start.startsWith("%PDF");
          const validEnd = end.includes("%%EOF");

          resolve(validStart && validEnd);
        };

        // Lê todo o arquivo (pode ser pesado em PDFs grandes, mas garante checagem correta)
        reader.readAsArrayBuffer(file);
      });
    },
    async isRealIMG(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = function (e) {
          const arr = new Uint8Array(e.target.result);
          // JPEG: começa com FF D8
          const isJPEG = arr[0] === 0xff && arr[1] === 0xd8;
          // PNG: começa com 89 50 4E 47 0D 0A 1A 0A
          const isPNG =
            arr[0] === 0x89 &&
            arr[1] === 0x50 &&
            arr[2] === 0x4e &&
            arr[3] === 0x47 &&
            arr[4] === 0x0d &&
            arr[5] === 0x0a &&
            arr[6] === 0x1a &&
            arr[7] === 0x0a;
          // HEIC: começa com 'ftypheic' ou 'ftypheix' ou 'ftypmif1' (offset 4)
          const brand = String.fromCharCode(...arr.subarray(4, 12));
          const isHEIC =
            brand.startsWith("ftypheic") ||
            brand.startsWith("ftypheix") ||
            brand.startsWith("ftypmif1");
          resolve(isJPEG || isPNG || isHEIC);
        };
        reader.readAsArrayBuffer(file);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
.p-12 {
  padding: 3rem;
}
.border {
  border-width: 1px;
  border-style: dashed;
  text-align: center;
}
.border-gray-300 {
  border-color: #b8b8b8;
}
.bg-gray-100 {
  background-color: #dbeffd;
}
.w-px {
  width: 1px;
}
.absolute {
  position: absolute;
}
.overflow-hidden {
  overflow: hidden;
}
.opacity-0 {
  opacity: 0;
}
.h-px {
  height: 1px;
}
.block {
  display: block;
}
.cursor-pointer {
  cursor: pointer;
}
.bg-green-300 {
  background-color: #9ae6b4;
}
.underline {
  text-decoration: underline;
}
.extension {
  font-weight: 700;
  font-size: 11px;
}
</style>
